import { ActivatedRoute } from '@angular/router';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesStatus, MessagesTitles } from './../../../models/messages';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LINEA,CONFIG } from 'app/models/ConfiguracionContratoMarco.model';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { environment } from 'environments/environment';

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-configuracion-contrato-marco',
  templateUrl: './configuracion-contrato-marco.component.html',
  styleUrls: ['./configuracion-contrato-marco.component.scss'],
  providers:[MessagesTitles,MessagesStatus,{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ConfiguracionContratoMarcoComponent implements OnInit {
  
  @Output() cerrarPopUp = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  razSocial : string;
  editar:boolean;
  loading:boolean = false;
  isLoading = true;
  save:boolean = false;
  contactosArray: any;
  user:any;
 
  formConfig : FormGroup;
  formLinea : FormGroup;
  idEmpresa : string;
  Titulo :string;
  
  lineaSoles:any = '';
  lineaDolares:any = '';
  dataEnviar :any={};
  linea : LINEA[] = [];
  config : CONFIG[] = [];
  Fecha = moment();
  IDCMarco :any;

  
  operaciones : any = [];
  operacionesDet : any =[];
  rProvCombo : any =[];
  rProvArray : any =[];
  rRefBancariaArray : any =[];
  rProvEmail : string;
  rProvRefBancarias : any =[];
  rProvRefBancariasDolares : any =[];
  dataConfigConfirming: any;
  arrayConfiguracion:any;
  newArray:any=[];

  constructor(private empresasService : EmpresasService ,  
              private routerActive:ActivatedRoute,
              private datePipe: DatePipe ,
              private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles) { 

    this.dataConfigConfirming = empresasService.dataContratoMarco
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Contrato marco";
    this.IDCMarco = empresasService.dataContratoMarco.IDCMarco;
    this.editar = false;

    this.routerActive.params.subscribe( params => {
      this.idEmpresa = params['id']; 
    })

     
    this.formConfig = new FormGroup({
        idConfiguracionConfirming:new FormControl('' , []),
        FlagFirmaDesembolso: new FormControl(false , []),
        FlagPagoInteres : new FormControl(false , []),
        FlagTasa : new FormControl(false, []),
        FlagPorcentajeAdelanto : new FormControl(false, []),
        FlagGastosAsociados : new FormControl(false, []),
        TasaMinima : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        TasaMaxima : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        PorcentajeAdelantoMinimo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        PorcentajeAdelantoMaximo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        GastoMinimo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        GastoMaximo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        Modificacion_Usuario : new FormControl(this.user.Usuario,  Validators.required),
        Modificacion_Canal : new FormControl('W', []),
        Modificacion_Fecha : new FormControl(this.datePipe.transform(this.Fecha,"yyyy-MM-dd"), []),
      });

    

  }

  ngOnInit() {
   this.razSocial = sessionStorage.getItem('razSocial');
   this.obtenerConfigConfirming(this.IDCMarco); 
  }

  obtenerConfigConfirming(IDCMarco:any){
  this.loading = true;

   this.empresasService.obtenerConfigConfirming(IDCMarco).subscribe(
     res =>{
         this.arrayConfiguracion = res;
         this.formConfig.controls['idConfiguracionConfirming'].setValue(res[0]['idConfiguracionConfirming']); 
         this.formConfig.controls['FlagFirmaDesembolso'].setValue(res[0]['FlagFirmaDesembolso']); 
         this.formConfig.controls['FlagPagoInteres'].setValue(res[0]['FlagPagoInteres']); 
         this.formConfig.controls['FlagTasa'].setValue(res[0]['FlagTasa']); 
         this.formConfig.controls['FlagPorcentajeAdelanto'].setValue(res[0]['FlagPorcentajeAdelanto']); 
         this.formConfig.controls['FlagGastosAsociados'].setValue(res[0]['FlagGastosAsociados']); 
         this.formConfig.controls['TasaMinima'].setValue(res[0]['TasaMinima']*100); 
         this.formConfig.controls['TasaMaxima'].setValue(res[0]['TasaMaxima']*100); 
         this.formConfig.controls['PorcentajeAdelantoMinimo'].setValue(res[0]['PorcentajeAdelantoMinimo']*100); 
         this.formConfig.controls['PorcentajeAdelantoMaximo'].setValue(res[0]['PorcentajeAdelantoMaximo']*100); 
         this.formConfig.controls['GastoMinimo'].setValue(res[0]['GastoMinimo']*100); 
         this.formConfig.controls['GastoMaximo'].setValue(res[0]['GastoMaximo']*100); 

         for( let item of res[0].LineaMonetaria){
            this.newArray.push(item)
         }

         this.lineaSoles = this.newArray[0].LineaTotal
         this.lineaDolares = this.newArray[1].LineaTotal

         this.loading = false;
     },err =>{
         Swal.fire({
             title: "¡Algo salió mal!",
             text:  err.error['error'],
             type: "warning",
             allowOutsideClick: true,
             heightAuto: false 
         });
         this.loading = false;
     }
   )
  }
  
  actualizarConfiguracion(){
    this.loading = true;
    this.formatearForm();
    this.dataEnviar.Linea = [];

    if(this.lineaSoles == '' || this.lineaSoles == null) {
      this.lineaSoles = 0.00
      this.linea.push({
        idLineaMonetaria:this.newArray[0].idLineaMonetaria,
        Moneda:2,LineaTotal:this.lineaSoles,
        LineaDisponible:this.lineaSoles,
        Modificacion_Usuario:this.user.Usuario,
        Modificacion_Canal:"W",
        Modificacion_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }else{
      this.linea.push({
        idLineaMonetaria: this.newArray[0].idLineaMonetaria,
        Moneda:2,LineaTotal:Number(this.lineaSoles).toFixed(2) ,
        LineaDisponible:Number(this.lineaSoles).toFixed(2),
        Modificacion_Usuario:this.user.Usuario,
        Modificacion_Canal:"W",
        Modificacion_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }
    if (this.lineaDolares == '' || this.lineaDolares == null) {
      this.lineaDolares = 0.00
      this.linea.push({
        idLineaMonetaria: this.newArray[1].idLineaMonetaria,
        Moneda:3,LineaTotal:this.lineaDolares ,
        LineaDisponible:this.lineaDolares,
        Modificacion_Usuario:this.user.Usuario,
        Modificacion_Canal:"W",
        Modificacion_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }else{
      this.linea.push({
        idLineaMonetaria: this.newArray[1].idLineaMonetaria,
        Moneda:3,LineaTotal:Number(this.lineaDolares).toFixed(2) ,
        LineaDisponible:Number(this.lineaDolares).toFixed(2),
        Modificacion_Usuario:this.user.Usuario,
        Modificacion_Canal:"W",
        Modificacion_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }
        for (const item of this.linea) {
          this.dataEnviar.Linea.push(item);
        }
      
      console.log('dataConfig', this.formConfig.getRawValue())
      console.log('dataEnviarfinal',this.dataEnviar)
      this.empresasService.actualizarConfigConfirming(this.dataEnviar)
      .subscribe(res => {
        this.loading = false;
        this.save = true;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Configuración no actualizada. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })       

  }  
  
  formatearForm(){

    if (this.formConfig.controls['FlagFirmaDesembolso'].value == true ){
      this.formConfig.controls['FlagFirmaDesembolso'].setValue(1)
    }else{
      this.formConfig.controls['FlagFirmaDesembolso'].setValue(0)
    }
    if (this.formConfig.controls['FlagPagoInteres'].value == true ){
      this.formConfig.controls['FlagPagoInteres'].setValue(1)
    }else{
      this.formConfig.controls['FlagPagoInteres'].setValue(0)
    }
    if (this.formConfig.controls['FlagTasa'].value == true ){
      this.formConfig.controls['FlagTasa'].setValue(1);
    }else{
      this.formConfig.controls['FlagTasa'].setValue(0)
    }
    if (this.formConfig.controls['FlagPorcentajeAdelanto'].value == true ){
      this.formConfig.controls['FlagPorcentajeAdelanto'].setValue(1);
    }else{
      this.formConfig.controls['FlagPorcentajeAdelanto'].setValue(0)
    }
    if (this.formConfig.controls['FlagGastosAsociados'].value == true ){
      this.formConfig.controls['FlagGastosAsociados'].setValue(1)
    }else{
      this.formConfig.controls['FlagGastosAsociados'].setValue(0)
    }

    this.config.push({
      idConfiguracionConfirming:this.formConfig.controls['idConfiguracionConfirming'].value,
      FlagFirmaDesembolso:this.formConfig.controls['FlagFirmaDesembolso'].value,
      FlagGastosAsociados:this.formConfig.controls['FlagGastosAsociados'].value ,
      FlagPagoInteres:this.formConfig.controls['FlagPagoInteres'].value,
      FlagPorcentajeAdelanto:this.formConfig.controls['FlagPorcentajeAdelanto'].value,
      FlagTasa:this.formConfig.controls['FlagTasa'].value,
      GastoMaximo:Number(this.formConfig.controls['GastoMaximo'].value/100).toFixed(4),
      GastoMinimo:Number(this.formConfig.controls['GastoMinimo'].value/100).toFixed(4),
      PorcentajeAdelantoMaximo:Number(this.formConfig.controls['PorcentajeAdelantoMaximo'].value/100).toFixed(4),
      PorcentajeAdelantoMinimo:Number(this.formConfig.controls['PorcentajeAdelantoMinimo'].value/100).toFixed(4),
      TasaMaxima:Number(this.formConfig.controls['TasaMaxima'].value/100).toFixed(4),
      TasaMinima:Number(this.formConfig.controls['TasaMinima'].value/100).toFixed(4),
      Modificacion_Usuario:this.formConfig.controls['Modificacion_Usuario'].value,
      Modificacion_Canal:this.formConfig.controls['Modificacion_Canal'].value,
      Modificacion_Fecha:this.formConfig.controls['Modificacion_Fecha'].value,
     });

     this.dataEnviar.Config = [];
     for (const item of this.config) {
      this.dataEnviar.Config.push(item);
    }

  }
  
  CerrarPopUp(){
    this.cerrarPopUp.emit();
  }

}
